import { IBuilder, Builder } from 'builder-pattern';
import { ForumCategoryInterface } from '../forum-category/forum-category.interface';

export interface ForumThreadInterface {
  id: number;
  categoryID: number;
  title: string;
  isReadOnly: boolean;
  isPinned: boolean;
  isDeleted: boolean;
  messageCount?: number;
  category?: ForumCategoryInterface;
  createdBy: {
    id: number;
    username: string;
  };
  lastMessageBy?: {
    id: number;
    username: string;
  };
  lastActivityAt?: string;
  createdAt: string;
  updatedAt: string;
}

export namespace ForumThreadInterface {
  export function builder(
    template?: Partial<ForumThreadInterface>
  ): IBuilder<ForumThreadInterface> {
    return Builder<ForumThreadInterface>(template);
  }
}